import {post} from '../utils'

export default host => ( id ) => post(`${host}/contentCreations/${id}/favorite`)
  .then(() => localStorage.setItem("lastFavorited", "creation"))
